import { colors } from "../../style";

// Shared inline style fragments for one-off layouts
export const ui = {
  muted: { color: colors.textMuted },
  label: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: colors.textLight,
  },
  pageTitle: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: 1.25,
    color: colors.text,
  },
  sectionTitle: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 600,
    color: colors.text,
  },
  // Label stacked above its control
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    fontSize: "12px",
    fontWeight: 600,
    color: colors.textMuted,
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "9px 12px",
    borderRadius: "10px",
    background: colors.surface,
    border: `1px solid ${colors.border}`,
  },
  card: {
    borderRadius: "14px",
    background: colors.surface,
    border: `1px solid ${colors.border}`,
    padding: "16px",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "9px 10px",
    borderRadius: "8px",
    border: `1px solid ${colors.borderStrong}`,
    background: colors.pageBackground,
    color: colors.text,
    font: "inherit",
    fontSize: "14px",
    outline: "none",
  },
  error: { color: colors.errorText, fontSize: "13px", margin: 0 },
  kbd: {
    fontSize: "11px",
    padding: "1px 6px",
    borderRadius: "5px",
    border: "1px solid rgba(255, 255, 255, 0.15)",
  },
};
